import http from '../../../http/base';

export default ({ API_PATHS }) => ({
    getGeneralInfo: memberId => http.get(API_PATHS.generalInfo, { params: { memberId } })
});